<template>
  <div class="col-12 col-lg-6 c g">
    <br>
    <div class="card">
      <div class="card-header" style="padding: 20px; display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center;">
        <img v-if="info.logo" :src="info.logo" style="width: 90px; height: 90px; border-radius: 50%; object-fit: cover; margin-bottom: 10px; border: 2px solid #eee;">
        <h3 v-if="info.school_name" style="margin-bottom: 8px;">{{ info.school_name }}</h3>
        <h4 class="text-primary" style="margin: 0;">الاستعلام عن لجنة الطالب</h4>
      </div>
      <div class="card-body">
        <div class="form-group">
          <label style="font-size: 18px; font-weight: bold;">رقم هوية الطالب</label>
          <input type="text" class="form-control text-center" style="font-size: 28px; height: 70px; letter-spacing: 3px;" v-model="number" placeholder="ادخل رقم الهوية..." @input="convertArabic" @keyup.enter="search()" :disabled="loading">
        </div>
        <div class="col-12 text-center g">
          <button class="btn btn-primary btn-lg btn-block" style="font-size: 20px; padding: 15px;" @click="search()" :disabled="loading">
            <i class="fa fa-search"></i> بحث
          </button>
        </div>
        <div v-if="loading" class="col-12 text-center g">
          <i class="fa fa-spinner fa-spin"></i> جاري البحث...
        </div>
        <div v-if="error" class="alert alert-warning text-center g">
          {{ error }}
        </div>
        <div v-if="result && result.results && result.results.length" class="g">
          <hr>
          <div class="alert alert-success text-center">
            <h5>تم العثور على بيانات الطالب</h5>
          </div>
          <div v-for="(r, i) in result.results" :key="i" class="card border-success" style="margin-bottom: 12px;">
            <div class="card-body">
              <table class="table table-bordered" style="margin-bottom: 0;">
                <tbody>
                  <tr>
                    <th style="width: 40%; background: #f8f9fa;">الاسم</th>
                    <td>{{ r.name }}</td>
                  </tr>
                  <tr>
                    <th style="background: #f8f9fa;">رقم الهوية</th>
                    <td>{{ r.number }}</td>
                  </tr>
                  <tr v-if="r.classname">
                    <th style="background: #f8f9fa;">الصف</th>
                    <td>{{ classname(r.classname) }}</td>
                  </tr>
                  <tr v-if="r.classroom">
                    <th style="background: #f8f9fa;">الفصل</th>
                    <td>{{ r.classroom }}</td>
                  </tr>
                  <tr v-if="r.serial">
                    <th style="background: #f8f9fa;">رقم الجلوس</th>
                    <td><strong style="font-size: 18px; color: #28a745;">{{ r.serial }}</strong></td>
                  </tr>
                  <tr>
                    <th style="background: #f8f9fa;">اللجنة</th>
                    <td><strong style="color: #007bff;">{{ r.committee }}</strong></td>
                  </tr>
                  <tr>
                    <th style="background: #f8f9fa;">مقر اللجنة</th>
                    <td v-if="r.address"><strong>{{ r.address }}</strong></td>
                    <td v-else class="text-muted">غير محدد</td>
                  </tr>
                  <tr v-if="r.date">
                    <th style="background: #f8f9fa;">تاريخ التوزيع</th>
                    <td class="text-muted">{{ r.date }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 text-center text-muted">
      الخدمة مقدمة من <a href="https://tahdir.net">التحضير الذكي</a>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      number: '',
      loading: false,
      error: '',
      result: null,
      info: { school_name: '', logo: '' },
      user_id: window.location.href.split('find-comm/')[1]?.split(/[?#]/)[0]
    }
  },
  created(){
    var g = this;
    $.post(api + '/general/find-comm-info', {
      user_id: g.user_id
    }).then(function(r){
      if(r.status == 100){ g.info = r.response; }
    })
  },
  methods: {
    classname(name){
      if(!name) return '';
      try{
        var classnames = JSON.parse(localStorage.getItem("classnames") || 'null');
        if(classnames){
          var found = classnames.find(function(x){ return x.classname == name || x.original == name; });
          if(found && found.title) return found.title;
        }
      }catch(e){}
      return name;
    },
    convertArabic(){
      var map = {'٠':'0','١':'1','٢':'2','٣':'3','٤':'4','٥':'5','٦':'6','٧':'7','٨':'8','٩':'9','۰':'0','۱':'1','۲':'2','۳':'3','۴':'4','۵':'5','۶':'6','۷':'7','۸':'8','۹':'9'};
      this.number = (this.number || '').replace(/[٠-٩۰-۹]/g, function(d){ return map[d] || d; });
    },
    search(){
      var g = this;
      g.convertArabic();
      if(!g.number || !g.number.trim()){
        g.error = 'برجاء ادخال رقم الهوية';
        g.result = null;
        return;
      }
      g.loading = true;
      g.error = '';
      g.result = null;
      $.post(api + '/general/find-comm', {
        user_id: g.user_id,
        number: g.number.trim()
      }).then(function(r){
        g.loading = false;
        if(r.status != 100){
          g.error = r.response;
        }else{
          g.result = r.response;
        }
      }).fail(function(){
        g.loading = false;
        g.error = 'حدث خطأ في الاتصال';
      })
    }
  }
}
</script>

<style>
</style>
